/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbPatientDetailsExternalEhrPatientLeadsInnerFacility } from './HchbPatientDetailsExternalEhrPatientLeadsInnerFacility';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerFacilityFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerFacilityFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerFacilityToJSON,
} from './HchbPatientDetailsExternalEhrPatientLeadsInnerFacility';
import type { HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo } from './HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoToJSON,
} from './HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo';
import type { HchbPatientDetailsExternalEhrPatientLeadsInnerStatus } from './HchbPatientDetailsExternalEhrPatientLeadsInnerStatus';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerStatusFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerStatusFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerStatusToJSON,
} from './HchbPatientDetailsExternalEhrPatientLeadsInnerStatus';
import type { HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist } from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistToJSON,
} from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist';

/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInner
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInner {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInner
     */
    lead_received_date?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInner
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInner
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInner
     */
    source_name?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInner
     */
    status_id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInner
     */
    connector?: HchbPatientDetailsExternalEhrPatientLeadsInnerConnectorEnum;
    /**
     * 
     * @type {HchbPatientDetailsExternalEhrPatientLeadsInnerStatus}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInner
     */
    status?: HchbPatientDetailsExternalEhrPatientLeadsInnerStatus;
    /**
     * 
     * @type {HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInner
     */
    waitlist?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInner
     */
    admission_status?: HchbPatientDetailsExternalEhrPatientLeadsInnerAdmissionStatusEnum;
    /**
     * 
     * @type {HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInner
     */
    screener_lead_info?: HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo;
    /**
     * 
     * @type {HchbPatientDetailsExternalEhrPatientLeadsInnerFacility}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInner
     */
    facility?: HchbPatientDetailsExternalEhrPatientLeadsInnerFacility;
}


/**
 * @export
 */
export const HchbPatientDetailsExternalEhrPatientLeadsInnerConnectorEnum = {
    Aida: 'Aida',
    Aidin: 'Aidin',
    Ensocare: 'Ensocare',
    EnsocareVa: 'Ensocare VA',
    EpicCareLink: 'EpicCare Link',
    EpicCareLinkAlbanyMed: 'EpicCare Link Albany Med',
    EpicCareLinkAllinaHealth: 'EpicCare Link Allina Health',
    EpicCareLinkAsante: 'EpicCare Link Asante',
    EpicCareLinkAscension: 'EpicCare Link Ascension',
    EpicCareLinkAspirusHealth: 'EpicCare Link Aspirus Health',
    EpicCareLinkAtriumHealth: 'EpicCare Link Atrium Health',
    EpicCareLinkBaptistHealth: 'EpicCare Link Baptist Health',
    EpicCareLinkBenefisHealthSystem: 'EpicCare Link Benefis Health System',
    EpicCareLinkBaylorScottWhiteHealth: 'EpicCare Link Baylor Scott & White Health',
    EpicCareLinkBonSecoursMercyHealth: 'EpicCare Link Bon Secours Mercy Health',
    EpicCareLinkBostonMedicalCenter: 'EpicCare Link Boston Medical Center',
    EpicCareLinkBronsonHealthcare: 'EpicCare Link Bronson Healthcare',
    EpicCareLinkBryanHealth: 'EpicCare Link Bryan Health',
    EpicCareLinkBsaHospital: 'EpicCare Link BSA Hospital',
    EpicCareLinkCapeCodHealthcare: 'EpicCare Link Cape Cod Healthcare',
    EpicCareLinkCaroMont: 'EpicCare Link CaroMont',
    EpicCareLinkCarolinaEast: 'EpicCare Link Carolina East',
    EpicCareLinkErlanger: 'EpicCare Link Erlanger',
    EpicCareLinkCentraCare: 'EpicCare Link CentraCare',
    EpicCareLinkChristusHealth: 'EpicCare Link CHRISTUS Health',
    EpicCareLinkConeHealth: 'EpicCare Link Cone Health',
    EpicCareLinkCovenantHealthCare: 'EpicCare Link Covenant HealthCare',
    EpicCareLinkDeaconess: 'EpicCare Link Deaconess',
    EpicCareLinkDenverHealth: 'EpicCare Link Denver Health',
    EpicCareLinkDukeHealth: 'EpicCare Link Duke Health',
    EpicCareLinkEcuHealth: 'EpicCare Link ECU Health',
    EpicCareLinkElCaminoHealth: 'EpicCare Link El Camino Health',
    EpicCareLinkEnloeHealth: 'EpicCare Link Enloe Health',
    EpicCareLinkFirstHealth: 'EpicCare Link FirstHealth',
    EpicCareLinkFmolhsCareConnect: 'EpicCare Link FMOLHS CareConnect',
    EpicCareLinkParkview: 'EpicCare Link Parkview',
    EpicCareLinkGenesisHealthcareSystem: 'EpicCare Link Genesis Healthcare System',
    EpicCareLinkHartfordHealthCare: 'EpicCare Link Hartford HealthCare',
    EpicCareLinkHackensackMeridianHealth: 'EpicCare Link Hackensack Meridian Health',
    EpicCareLinkHealthPartners: 'EpicCare Link HealthPartners',
    EpicCareLinkHealtheConnection: 'EpicCare Link HealtheConnection',
    EpicCareLinkHennepinCountyMedicalCenter: 'EpicCare Link Hennepin County Medical Center',
    EpicCareLinkHillcrestHealthCareSystem: 'EpicCare Link Hillcrest HealthCare System',
    EpicCareLinkHospitalSistersHealthSystem: 'EpicCare Link Hospital Sisters Health System',
    EpicCareLinkHurleyMedicalCenter: 'EpicCare Link Hurley Medical Center',
    EpicCareLinkIowaHealthCare: 'EpicCare Link Iowa Health Care',
    EpicCareLinkIntegrisHealth: 'EpicCare Link Integris Health',
    EpicCareLinkJupiterMedicalCenter: 'EpicCare Link Jupiter Medical Center',
    EpicCareLinkKaiserPermanente: 'EpicCare Link Kaiser Permanente',
    EpicCareLinkKingsDaughtersHealthSystem: 'EpicCare Link King\'s Daughters Health System',
    EpicCareLinkLegacyHealthyPlanet: 'EpicCare Link Legacy Healthy Planet',
    EpicCareLinkMHealthFairview: 'EpicCare Link M Health Fairview',
    EpicCareLinkMainLineHealth: 'EpicCare Link Main Line Health',
    EpicCareLinkMayoClinic: 'EpicCare Link Mayo Clinic',
    EpicCareLinkMercy: 'EpicCare Link Mercy',
    EpicCareLinkMethodistHospitals: 'EpicCare Link Methodist Hospitals',
    EpicCareLinkMethodistHealthSystem: 'EpicCare Link Methodist Health System',
    EpicCareLinkMiddlesexHealth: 'EpicCare Link Middlesex Health',
    EpicCareLinkMyMichiganHealth: 'EpicCare Link MyMichigan Health',
    EpicCareLinkNortonHealthcare: 'EpicCare Link Norton Healthcare',
    EpicCareLinkNorthMemorialHealth: 'EpicCare Link North Memorial Health',
    EpicCareLinkOhioHealth: 'EpicCare Link OhioHealth',
    EpicCareLinkOklahomaHeartHospital: 'EpicCare Link Oklahoma Heart Hospital',
    EpicCareLinkOsfHealthCare: 'EpicCare Link OSF HealthCare',
    EpicCareLinkOwensboroHealth: 'EpicCare Link Owensboro Health',
    EpicCareLinkPiedmont: 'EpicCare Link Piedmont',
    EpicCareLinkProvidence: 'EpicCare Link Providence',
    EpicCareLinkSaintFrancis: 'EpicCare Link Saint Francis',
    EpicCareLinkShannonHealth: 'EpicCare Link Shannon Health',
    EpicCareLinkStElizabethHealthcare: 'EpicCare Link St. Elizabeth Healthcare',
    EpicCareLinkStormontVailHealth: 'EpicCare Link Stormont Vail Health',
    EpicCareLinkSsmHealth: 'EpicCare Link SSM Health',
    EpicCareLinkTexasHealth: 'EpicCare Link Texas Health',
    EpicCareLinkTheQueensHealthSystem: 'EpicCare Link The Queen\'s Health System',
    EpicCareLinkThedaCare: 'EpicCare Link ThedaCare',
    EpicCareLinkTriHealth: 'EpicCare Link TriHealth',
    EpicCareLinkTrinityHealth: 'EpicCare Link Trinity Health',
    EpicCareLinkUcHealth: 'EpicCare Link UCHealth',
    EpicCareLinkUncHealth: 'EpicCare Link UNC Health',
    EpicCareLinkUConnHealth: 'EpicCare Link UConn Health',
    EpicCareLinkUnityPointHealth: 'EpicCare Link UnityPoint Health',
    EpicCareLinkUniversityOfCincinnati: 'EpicCare Link University of Cincinnati',
    EpicCareLinkUniversityOfKansas: 'EpicCare Link University of Kansas',
    EpicCareLinkUniversityOfMarylandMedicalSystem: 'EpicCare Link University of Maryland Medical System',
    EpicCareLinkUniversityHealth: 'EpicCare Link University Health',
    EpicCareLinkUniversityOfUtah: 'EpicCare Link University of Utah',
    EpicCareLinkUpmcPinnacle: 'EpicCare Link UPMC Pinnacle',
    EpicCareLinkSouthShoreHealth: 'EpicCare Link South Shore Health',
    EpicCareLinkStLukes: 'EpicCare Link St. Luke\'s',
    EpicCareLinkPremierHealth: 'EpicCare Link Premier Health',
    EpicCareLinkUtHealthEastTexas: 'EpicCare Link UT Health East Texas',
    EpicCareLinkUtSouthwesternMedicalCenter: 'EpicCare Link UT Southwestern Medical Center',
    EpicCareLinkVitruvianHealth: 'EpicCare Link Vitruvian Health',
    EpicCareLinkWellstar: 'EpicCare Link Wellstar',
    EpicCareLinkKetteringHealth: 'EpicCare Link Kettering Health',
    EpicCareLinkOlmstedMedicalCenter: 'EpicCare Link Olmsted Medical Center',
    EpicCareLinkFranciscanHealth: 'EpicCare Link Franciscan Health',
    EpicCareLinkMohawkValleyHealthSystem: 'EpicCare Link Mohawk Valley Health System',
    EpicCareLinkGeisinger: 'EpicCare Link Geisinger',
    Fax: 'Fax',
    ManualUpload: 'Manual Upload',
    ManualCopy: 'Manual Copy',
    Repisodic: 'Repisodic',
    WellSkyIntake: 'WellSky Intake',
    WellSkyIntakeCarePortQuickCase: 'WellSky Intake CarePort QuickCase',
    WellSkyCarePortReferralIntake: 'WellSky CarePort Referral Intake',
    WellSkyReferralManagement: 'WellSky Referral Management',
    WellSkyReferralManagementWebReferral: 'WellSky Referral Management Web Referral',
    FourNext: 'Four Next'
} as const;
export type HchbPatientDetailsExternalEhrPatientLeadsInnerConnectorEnum = typeof HchbPatientDetailsExternalEhrPatientLeadsInnerConnectorEnum[keyof typeof HchbPatientDetailsExternalEhrPatientLeadsInnerConnectorEnum];

/**
 * @export
 */
export const HchbPatientDetailsExternalEhrPatientLeadsInnerAdmissionStatusEnum = {
    Booked: 'Booked',
    MovedIn: 'Moved-In',
    MovedOut: 'Moved-Out',
    Lost: 'Lost',
    Hospitalized: 'Hospitalized'
} as const;
export type HchbPatientDetailsExternalEhrPatientLeadsInnerAdmissionStatusEnum = typeof HchbPatientDetailsExternalEhrPatientLeadsInnerAdmissionStatusEnum[keyof typeof HchbPatientDetailsExternalEhrPatientLeadsInnerAdmissionStatusEnum];


/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInner interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInner {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_received_date': !exists(json, 'lead_received_date') ? undefined : json['lead_received_date'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'source_name': !exists(json, 'source_name') ? undefined : json['source_name'],
        'status_id': !exists(json, 'status_id') ? undefined : json['status_id'],
        'connector': !exists(json, 'connector') ? undefined : json['connector'],
        'status': !exists(json, 'status') ? undefined : HchbPatientDetailsExternalEhrPatientLeadsInnerStatusFromJSON(json['status']),
        'waitlist': !exists(json, 'waitlist') ? undefined : HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistFromJSON(json['waitlist']),
        'admission_status': !exists(json, 'admission_status') ? undefined : json['admission_status'],
        'screener_lead_info': !exists(json, 'screener_lead_info') ? undefined : HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoFromJSON(json['screener_lead_info']),
        'facility': !exists(json, 'facility') ? undefined : HchbPatientDetailsExternalEhrPatientLeadsInnerFacilityFromJSON(json['facility']),
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerToJSON(value?: HchbPatientDetailsExternalEhrPatientLeadsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_received_date': value.lead_received_date,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'source_name': value.source_name,
        'status_id': value.status_id,
        'connector': value.connector,
        'status': HchbPatientDetailsExternalEhrPatientLeadsInnerStatusToJSON(value.status),
        'waitlist': HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistToJSON(value.waitlist),
        'admission_status': value.admission_status,
        'screener_lead_info': HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoToJSON(value.screener_lead_info),
        'facility': HchbPatientDetailsExternalEhrPatientLeadsInnerFacilityToJSON(value.facility),
    };
}

